import logo from '../assets/logo.png'
import { BsTwitterX, BsLinkedin } from "react-icons/bs";

const Footer = ({ lightMode, scroll, home }) => {
    return (
        <div className={'section ' + (lightMode ? 'light-primary' : 'dark-primary')}>
            <hr className="footer-hr" />
            <div className="footer">
                <img onClick={() => scroll(home)} src={logo} alt="" />
                <p>©2024 - Designed and built by Aka</p>
                <div className="footer-logos">
                    <a href="https://linkedin.com/in/ogogor-chimadika-888195246"><BsLinkedin style={{ fontSize: "1.5rem", cursor: "pointer" }} /></a>
                    <a href="https://x.com/akachicodes"><BsTwitterX style={{ fontSize: "1.5rem", cursor: "pointer" }} /></a>
                </div>
            </div>
        </div>
    )
}

export default Footer